import Checkbox from "@/components/UI/Checkbox/Checkbox";
import BasicInput from "@/components/UI/Inputs/BasicInput";
import TimeInput from "@/components/UI/Inputs/TimeInput";
import ClassicSelect from "@/components/UI/ClassicSelect/ClassicSelect";

export default [
    Checkbox,
    BasicInput,
    TimeInput,
    ClassicSelect,
]